const mediaItems = [
  {
    title: '娱乐圈最新爆料实锤合集',
    desc: '近期娱乐圈多位明星爆料汇总，包含独家内幕与多方求证信息，持续追踪事件进展。',
    icon: 'ri-play-circle-line',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20entertainment%20news%20visual%20with%20soft%20gradients%20and%20geometric%20shapes%2C%20cinematic%20lighting%2C%20dark%20crimson%20and%20gold%20accents%2C%20modern%20editorial%20style%2C%20no%20text%2C%20clean%20aesthetic&width=800&height=450&seq=media-card-1&orientation=landscape',
  },
  {
    title: '网红圈黑料爆料第一现场',
    desc: '知名网红被曝黑料，相关视频与聊天记录曝光，事件始末完整梳理与多方回应汇总。',
    icon: 'ri-live-line',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20in%20warm%20amber%20and%20coral%20tones%2C%20flowing%20curves%20suggesting%20digital%20media%2C%20soft%20gradient%20background%2C%20modern%20editorial%20photography%20style%2C%20no%20text%2C%20dramatic%20lighting&width=800&height=450&seq=media-card-2&orientation=landscape',
  },
  {
    title: '今日最新吃瓜视频爆料合集',
    desc: '7月30日最新爆出的热门吃瓜事件视频合集，包含多条独家爆料的完整视频资料。',
    icon: 'ri-vidicon-line',
    img: 'https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20art%20with%20deep%20red%20and%20gold%20hues%2C%20geometric%20shapes%20overlapping%2C%20cinematic%20atmosphere%2C%20modern%20news%20media%20aesthetic%2C%20no%20text%2C%20soft%20shadows%20and%20highlights&width=800&height=450&seq=media-card-3&orientation=landscape',
  },
  {
    title: '年度最大爆料事件深度回顾',
    desc: '今年以来最受关注的几次重大爆料事件回顾，从爆料到实锤的完整时间线梳理。',
    icon: 'ri-film-line',
    img: 'https://readdy.ai/api/search-image?query=Sophisticated%20abstract%20visual%20with%20crimson%20and%20bronze%20color%20palette%2C%20layered%20translucent%20shapes%2C%20editorial%20news%20style%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%2C%20elegant%20composition&width=800&height=450&seq=media-card-4&orientation=landscape',
  },
  {
    title: '吃瓜达人精选爆料视频集锦',
    desc: '由资深吃瓜达人精选的本月最具话题度的爆料视频，附详细事件背景与各方反应。',
    icon: 'ri-clapperboard-line',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20in%20warm%20terracotta%20and%20gold%20tones%2C%20fluid%20shapes%20suggesting%20entertainment%20news%2C%20soft%20gradient%20texture%2C%20no%20text%2C%20modern%20editorial%20aesthetic%2C%20clean%20design&width=800&height=450&seq=media-card-5&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1100px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          视频爆料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          热门爆料视频与内容集锦
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer group"
            >
              <div className="relative bg-background-300 aspect-video flex items-center justify-center">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-background-950/30 flex items-center justify-center group-hover:bg-background-950/40 transition-colors">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}